import { FC } from 'react';

import { IClientOptionTeam } from '~/store/client/types';
import { ReactComponent as DeleteIcon } from '~/ui/assets/images/delete.svg';
import ButtonIcon from '~/ui/components/common/ButtonIcon';

import AllocationClientRow from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/components/AllocationClientRow/AllocationClientRow';
import MemoField from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/components/MemoField/MemoField';
import TeamsField from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/components/TeamField/TeamsField';
import { ClientWithAllocation } from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/model/types';
import { useAddClientAllocationContext } from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/AddClientAllocation/context/AddClientAllocationContext';
import useClientAvailabilityMessages from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/EditClientAllocation/hooks/validateAllocations/useClientAvailabilityMessages';

import variables from '~/ui/assets/styles/colors.module.scss';

interface IProps {
  field: ClientWithAllocation & { id: string };
  clientIdx: number;
  teamMemberIdx: number;
  onRemove: (idx: number) => void;
  availableClientTeams?: IClientOptionTeam[];
  memberId: number;
}

const AllocationClientRowItem: FC<IProps> = ({
  field,
  clientIdx,
  teamMemberIdx,
  memberId,
  onRemove,
  availableClientTeams,
}) => {
  const MEMO_FIELD_NAME = `teamMembersAllocations.${teamMemberIdx}.clientsAllocations.${clientIdx}.memo`;
  const { currentUserRole } = useAddClientAllocationContext();

  const { alertMessage, noteMessage } = useClientAvailabilityMessages({
    clientId: field.clientId,
    memberId,
    teamMemberIdx,
  });

  const client = {
    photo: field.photo,
    name: field.name,
    isResolved: false,
    isCrisis: false,
    clientId: field.clientId,
    teams: availableClientTeams || (field.teams as unknown as IClientOptionTeam[]),
  };

  const handleDelete = () => {
    onRemove(clientIdx);
  };

  return (
    <AllocationClientRow
      client={client}
      alertMessage={alertMessage}
      noteMessage={noteMessage}
      memoField={<MemoField memoFieldName={MEMO_FIELD_NAME} />}
      teamsField={
        field.teams && currentUserRole.isGlobalUser ? (
          <TeamsField
            teams={client.teams}
            selectedTeamId={field.teamId}
            fieldName={`teamMembersAllocations.${teamMemberIdx}.clientsAllocations.${clientIdx}.teamId`}
          />
        ) : undefined
      }
      actions={
        <ButtonIcon onClick={handleDelete}>
          <DeleteIcon width={20} color={variables.colorRed} />
        </ButtonIcon>
      }
    />
  );
};

export default AllocationClientRowItem;
